import { FormsContext } from 'pages/Forms/context/FormsContext';
import React, { ReactElement, useContext } from 'react';
import styled from 'styled-components/macro';

interface Props {
  isRequired: boolean;
  index: number;
}

const RequiredSelector = ({ isRequired, index }: Props): ReactElement => {
  const { dispatch } = useContext(FormsContext);

  const handleRequiredToggle = (): void => {
    dispatch({ type: 'UPDATE_IS_REQUIRED_AT_INDEX', payload: { questionIndex: index, isRequired: !isRequired } });
  };

  return (
    <Wrapper>
      <Title>Required</Title>

      <Rectangle isSelected={isRequired} onClick={handleRequiredToggle}>
        <Circle isSelected={isRequired} />
      </Rectangle>
    </Wrapper>
  );
};

export default RequiredSelector;

const Wrapper = styled.div`
  display: flex;

  flex: 1 0 auto;
  justify-content: flex-end;
  align-items: center;
`;
const Title = styled.p`
  width: 57px;
  height: 17px;
  font-family: Helvetica;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #73747d;
`;

interface IRectangleProps {
  isSelected: boolean;
}

const Rectangle = styled.div<IRectangleProps>`
  display: flex;

  flex-direction: ${({ isSelected }): string => (isSelected ? 'row-reverse' : 'row')};
  align-items: center;
  width: 22px;
  height: 7px;
  border-radius: 3.5px;
  background-color: #c1c9ca;
  margin: 0 10px;
  cursor: pointer;
`;

interface ICircleProps {
  isSelected: boolean;
}

const Circle = styled.div<ICircleProps>`
  width: 13px;
  height: 13px;
  border-radius: 6.5px;
  background-color: ${({ isSelected }): string =>
    isSelected ? 'var(--chakra-colors-text-brand)' : 'var(--chakra-colors-text-default)'};
`;
